import React, { useState } from 'react'

import './what-we-do-page.css'
import CollaborationRequestForm from '../components/CollaborationRequestForm/CollaborationRequestForm'

const servicesData = [
  {
    title: 'Talleres, cursos y acciones formativas',
    description: 'Diseñamos actividades presenciales y online adaptadas a diferentes públicos.'
  },
  {
    title: 'Conferencias y presentaciones',
    description: 'Participamos como ponentes en congresos, jornadas, seminarios y encuentros profesionales.'
  },
  {
    title: 'Asesoramiento técnico',
    description: 'Orientación y acompañamiento para crear entornos respetuosos e inclusivos.'
  },
  {
    title: 'Elaboración de materiales',
    description: 'Recursos adaptados a las necesidades de cada organización.'
  },
  {
    title: 'Proyectos colaborativos',
    description: 'Trabajamos con asociaciones, administraciones y universidades en iniciativas de impacto social.'
  }
]

const collaborationsData = [
  'Capítulo "Menopausia" para Nuestra Guía de Justicia Reproductiva (Puerto Rico)',
  'Proyecto "Salud para disfrutar" de la RedCAPS',
  'Xarxa de Dones per la Salut (charlas y talleres)',
  'Jornada FeSMC Catalunya',
  'III Congreso Internacional de Antropología Feminista',
  'Jornada Participativa sobre Salud Sexual y Reproductiva (Andalucía)'
]

const WhatWeDoPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false)

  return (
    <>
      <section className='what-we-do-page' aria-label='Qué hacemos'>
      <a className='what-we-do-page__back-link' href='/asociacion'>
        <span aria-hidden='true'>←</span>
        Volver
      </a>

      <header className='what-we-do-page__hero'>
        <div className='what-we-do-page__hero-copy'>
          <span className='what-we-do-page__eyebrow'>Eje de intervención</span>
          <h1>Qué hacemos</h1>
          <p>
            La Vida en Rojo pone a disposición de administraciones públicas, universidades, centros educativos, entidades sociales, empresas y otras organizaciones su experiencia en cultura menstrual.
          </p>
        </div>
      </header>

      <div className='what-we-do-page__intro'>
        <p>
          Diseñamos propuestas adaptadas a cada contexto, combinando formación, asesoramiento, elaboración de materiales, acompañamiento técnico y desarrollo de proyectos colaborativos. Entendemos cada colaboración como una herramienta de transformación social.
        </p>
      </div>

      <section className='what-we-do-page__commitment' aria-label='Compromiso'>
        <div>
          <span className='what-we-do-page__eyebrow'>Compromiso</span>
          <p>
            Trabajamos para <strong>democratizar los cuidados, combatir la pobreza menstrual, favorecer la equidad laboral</strong> y <strong>promover el reconocimiento de la diversidad de las experiencias menstruales, cíclicas y climatéricas, desde una perspectiva feminista y de justicia ecosocial</strong>.
          </p>
        </div>
      </section>

      <section className='what-we-do-page__services' aria-labelledby='what-we-do-services-title'>
        <div className='what-we-do-page__section-heading'>
          <span>Servicios</span>
          <h2 id='what-we-do-services-title'>Cómo trabajamos</h2>
        </div>

        <div className='what-we-do-page__services-grid'>
          {servicesData.map((service, index) => (
            <article className='what-we-do-page__service' key={service.title}>
              <span className='what-we-do-page__service-number'>{String(index + 1).padStart(2, '0')}</span>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className='what-we-do-page__formations' aria-labelledby='what-we-do-formations-title'>
        <div className='what-we-do-page__section-heading'>
          <span>Formación</span>
          <h2 id='what-we-do-formations-title'>Talleres, cursos y acciones formativas</h2>
        </div>

        <div className='what-we-do-page__formations-grid'>
          <div className='what-we-do-page__formation-item'>
            <h3>Dirigidas a</h3>
            <ul>
              <li>Universidades</li>
              <li>Centros educativos</li>
              <li>Profesorado</li>
              <li>Administraciones públicas</li>
              <li>Empresas</li>
              <li>Entidades sociales</li>
              <li>Profesionales</li>
            </ul>
          </div>

          <div className='what-we-do-page__formation-item'>
            <h3>Temáticas</h3>
            <ul>
              <li>Cultura menstrual</li>
              <li>Educación menstrual</li>
              <li>Menarquia</li>
              <li>Perimenopausia-climaterio</li>
              <li>Salud menstrual</li>
              <li>Justicia menstrual</li>
              <li>Pobreza menstrual</li>
              <li>Masculinidades y cultura menstrual</li>
              <li>Ciclicidad y salud psicoemocional</li>
            </ul>
          </div>
        </div>
      </section>

      <section className='what-we-do-page__conferences' aria-labelledby='what-we-do-conferences-title'>
        <div className='what-we-do-page__section-heading'>
          <span>Visibilidad</span>
          <h2 id='what-we-do-conferences-title'>Conferencias, jornadas y congresos</h2>
        </div>

        <p className='what-we-do-page__section-intro'>
          Participamos como ponentes en congresos, jornadas, seminarios, universidades y encuentros profesionales. Tras la publicación del libro <strong>Educación Menstrual</strong>, ofrecemos conferencias dirigidas a instituciones académicas, administraciones y organizaciones interesadas en incorporar la educación menstrual desde una perspectiva feminista y de derechos.
        </p>
      </section>

      <section className='what-we-do-page__consultancy' aria-labelledby='what-we-do-consultancy-title'>
        <div className='what-we-do-page__section-heading'>
          <span>Asesoramiento</span>
          <h2 id='what-we-do-consultancy-title'>Para empresas y entidades</h2>
        </div>

        <p className='what-we-do-page__section-intro'>
          Ofrecemos orientación y acompañamiento a empresas, instituciones y organizaciones comprometidas con crear entornos respetuosos e inclusivos. Aportamos educación y buenas prácticas para contribuir a generar espacios laborales libres de prejuicios, estigmas y estereotipos.
        </p>

        <div className='what-we-do-page__consultancy-offerings'>
          <h3>Podemos desarrollar</h3>
          <ul>
            <li>Charlas y talleres</li>
            <li>Protocolos</li>
            <li>Formación para equipos</li>
            <li>Guías</li>
            <li>Buenas prácticas</li>
            <li>Asesoramiento técnico</li>
          </ul>
        </div>
      </section>

      <section className='what-we-do-page__materials' aria-labelledby='what-we-do-materials-title'>
        <div className='what-we-do-page__section-heading'>
          <span>Recursos</span>
          <h2 id='what-we-do-materials-title'>Elaboración de materiales</h2>
        </div>

        <p className='what-we-do-page__section-intro'>
          Diseñamos recursos adaptados a las necesidades de cada organización.
        </p>

        <div className='what-we-do-page__materials-list'>
          <h3>Tipos de materiales</h3>
          <ul>
            <li>Guías</li>
            <li>Materiales educativos</li>
            <li>Informes</li>
            <li>Recursos didácticos</li>
            <li>Publicaciones</li>
            <li>Campañas divulgativas</li>
          </ul>
        </div>
      </section>

      <section className='what-we-do-page__networks' aria-labelledby='what-we-do-networks-title'>
        <div className='what-we-do-page__section-heading'>
          <span>Colaboración</span>
          <h2 id='what-we-do-networks-title'>Proyectos y trabajo en red</h2>
        </div>

        <p className='what-we-do-page__section-intro'>
          Una de las señas de identidad de La Vida en Rojo es el trabajo colaborativo. Participamos e impulsamos proyectos junto a asociaciones, administraciones públicas, universidades, colectivos profesionales y entidades sociales para promover la cultura menstrual desde una perspectiva feminista, ecosocial y basada en derechos.
        </p>

        <div className='what-we-do-page__networks-grid'>
          <div className='what-we-do-page__network-item'>
            <h3>Colaboramos en</h3>
            <ul>
              <li>Campañas</li>
              <li>Jornadas</li>
              <li>Acciones comunitarias</li>
              <li>Proyectos educativos</li>
              <li>Programas institucionales</li>
              <li>Investigaciones</li>
              <li>Iniciativas culturales</li>
            </ul>
          </div>
        </div>
      </section>

      <section className='what-we-do-page__collaborations' aria-labelledby='what-we-do-collaborations-title'>
        <h2 id='what-we-do-collaborations-title'>Algunas colaboraciones y participaciones</h2>
        <p className='what-we-do-page__collaborations-intro'>
          A lo largo de estos años hemos colaborado con universidades, administraciones públicas, entidades sociales, redes profesionales y organizaciones de distintos ámbitos.
        </p>

        <ul className='what-we-do-page__collaborations-list'>
          {collaborationsData.map((collab) => (
            <li key={collab}>{collab}</li>
          ))}
        </ul>

        <a className='what-we-do-page__collaborations-link' href='/memorias'>
          Puedes consultar el detalle completo de nuestras actividades y colaboraciones año a año en la sección 'Memorias'
        </a>
      </section>

      <section className='what-we-do-page__cta' aria-labelledby='what-we-do-cta-title'>
        <div className='what-we-do-page__cta-content'>
          <h2 id='what-we-do-cta-title'>¿Hablamos?</h2>
          <p>
            Si representas a una universidad, administración pública, centro educativo, empresa, entidad social o colectivo profesional y quieres incorporar la cultura menstrual a vuestro ámbito de actuación, estaremos encantadas de diseñar una propuesta adaptada a vuestras necesidades.
          </p>
          <button onClick={() => setIsFormOpen(true)} className='what-we-do-page__cta-button'>
            Formulario de contacto
          </button>
        </div>
      </section>
    </section>

    <CollaborationRequestForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  )
}

export default WhatWeDoPage
